(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tessi-matratze-produktseite"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.tmReady === 'true') return;
      root.dataset.tmReady = 'true';

      const panels = Array.from(root.querySelectorAll('[data-tm-panel]'));
      const thumbs = Array.from(root.querySelectorAll('[data-tm-thumb]'));
      let current = 0;

      const show = (index) => {
        if (!panels.length) return;
        current = (index + panels.length) % panels.length;
        const update = () => {
          panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== current; });
          thumbs.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === current;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };
        if (document.startViewTransition) document.startViewTransition(update);
        else update();
      };

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.tmThumb))));
      root.querySelector('[data-tm-prev]')?.addEventListener('click', () => show(current - 1));
      root.querySelector('[data-tm-next]')?.addEventListener('click', () => show(current + 1));

      const variantSelect = root.querySelector('[data-tm-variant]');
      const price = root.querySelector('[data-tm-price]');
      const stickyPrice = root.querySelector('[data-tm-sticky-price]');
      const addButton = root.querySelector('[data-tm-add]');
      const stock = root.querySelector('[data-tm-stock]');

      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        const formattedPrice = option?.dataset.price || '';
        if (price) price.textContent = formattedPrice;
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
        }
        if (stock) {
          stock.classList.toggle('is-sold-out', !available);
          const label = stock.querySelector('span:last-child');
          if (label) label.textContent = available ? root.dataset.stockLabel : root.dataset.soldLabel;
        }
      });

      const buybox = root.querySelector('.tm__buybox');
      root.querySelector('[data-tm-scroll-buy]')?.addEventListener('click', () => buybox?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      root.querySelector('[data-tm-sticky-submit]')?.addEventListener('click', () => root.querySelector('.tm__form')?.requestSubmit());

      const track = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, product_id: root.id, ...detail });
      };

      root.querySelectorAll('[data-tm-track]').forEach((element) => {
        element.addEventListener('click', () => track('tessi_mattress_interaction', { action: element.dataset.tmTrack }));
      });

      root.querySelectorAll('.tm__faq').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) track('tessi_mattress_faq_open', { question: details.querySelector('summary')?.textContent?.trim() || '' });
        });
      });

      const trustpilotWidget = root.querySelector('.tm__trustpilot-widget');
      if (trustpilotWidget && window.Trustpilot?.loadFromElement) window.Trustpilot.loadFromElement(trustpilotWidget, true);
    };

    const initAll = (scope = document) => scope.querySelectorAll('.tm').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
